// extracted by mini-css-extract-plugin
export default {"root":"SpecSpecialization_root__gHZfO","darkText":"SpecSpecialization_darkText__2DTPX","specializationTypography":"SpecSpecialization_specializationTypography__0zzrh"};